import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

/**
 * Compteur GSAP — tous les [data-counter] d’un .s-key-figures
 * partent de 0 et finissent en même temps (durée fixe).
 */
const DURATION = 2

export class Counter {
  constructor () {
    this._sections = document.querySelectorAll('.s-key-figures')

    if (!this._sections.length) {
      return
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this._sections.forEach((section) => {
        section.querySelectorAll('[data-counter]').forEach((el) => {
          const value = parseFloat(el.dataset.value || '0')
          const decimals = parseInt(el.dataset.decimals || '0', 10) || 0
          el.textContent = decimals > 0 ? value.toFixed(decimals) : String(Math.round(value))
        })
      })
      return
    }

    this.init()
  }

  init () {
    gsap.registerPlugin(ScrollTrigger)

    this._sections.forEach((section) => {
      const counters = section.querySelectorAll('[data-counter]')
      if (!counters.length) {
        return
      }

      const tweens = []

      counters.forEach((el) => {
        const target = parseFloat(el.dataset.value || '0')
        const decimals = parseInt(el.dataset.decimals || '0', 10) || 0
        const state = { val: 0 }

        tweens.push(
          gsap.to(state, {
            val: target,
            duration: DURATION,
            ease: 'power2.out',
            paused: true,
            onUpdate: () => {
              el.textContent = decimals > 0
                ? state.val.toFixed(decimals)
                : String(Math.round(state.val))
            },
          })
        )
      })

      ScrollTrigger.create({
        trigger: section,
        start: 'top 80%',
        once: true,
        onEnter: () => {
          tweens.forEach((tween) => tween.play())
        },
      })
    })
  }
}
